import axios from "axios";
import "../../../App.css";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getGlobalVar, setGlobalVar } from "../../config/Config";
import Header from "../../../components/Header";

import { Space, Table, Tag, Button, Popconfirm, Tooltip } from "antd";
import { EditOutlined, DeleteOutlined } from "@ant-design/icons";
import { render } from "@testing-library/react";
import { BASE_URL } from "../../../config/Config";
import { getOrders } from "../../../repository/ordersApi";

const POSOrders = () => {
  // URLS
  const auth = JSON.parse(localStorage.getItem("auth"));
  const org = auth?.org;
  const categoriesUrl = `${BASE_URL}/accountingapi/GetProductCategories/?org=${org}`;
  const productsUrl = `${BASE_URL}/accountingapi/GetProduct/?org=${org}`;
  const imgUrl = "";
  const [globalVar, setValue] = useState(getGlobalVar());
  const [products, setProducts] = useState([]);
  const [showCreateForm, setShowCreateForm] = useState(false);

  const [productName, setProductName] = useState("");
  const [price, setPrice] = useState("");
  const [saleprice, setSalePrice] = useState("");

  const navigate = useNavigate();

  const [orders, setOrders] = useState([]);

  useEffect(() => {
    fetchOrders();
  }, []);

  const fetchOrders = async () => {
    try {
      const data = await getOrders();
      setOrders(data);
      setOrders(data);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    axios
      .get(`${categoriesUrl}`, {
        headers: {
          Authorization: "Bearer " + globalVar.Token,
        },
      })
      .then((res) => {
        //console.log(res.data);
      });
  }, []);

  useEffect(() => {
    axios
      .get(`${categoriesUrl}`, {
        headers: {
          Authorization: "Bearer " + globalVar.Token,
        },
      })
      .then((res) => {
        //console.log(res.data);
      });
  }, []);

  useEffect(() => {
    axios
      .get(`${productsUrl}`, {
        headers: {
          Authorization: "Bearer " + globalVar.Token,
        },
      })
      .then((res) => {
        const fetchedProducts = res.data.map((product) => ({
          ...product,
          Photo: `${product.Photo}`, // Prepend the base URL for images
        }));
        setProducts(fetchedProducts);
        //console.log(fetchedProducts);
      });
  }, []);

  const onCreateFormSubmit = (e) => {
    e.preventDefault();
    let productObj = {
      ProductName: productName,
      Price: price,
      SalesPrice: saleprice,
    };
  };

  const columns = [
    { title: "ID", dataIndex: "id", key: "id" },
    { title: "Order Ref", dataIndex: "order_ref", key: "order_ref" },
    { title: "Date", dataIndex: "date", key: "date" },
    { title: "Session", dataIndex: "session", key: "session" },
    {
      title: "Fiscal Position",
      dataIndex: "fiscal_position",
      key: "fiscal_position",
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (status) => (status ? "Completed" : "Pending"),
    },
    { title: "User", dataIndex: "User", key: "User" },
    {
      title: "Customer",
      dataIndex: "customer",
      key: "customer",
      render: (customer) => customer ?? "—",
    },
    {
      title: "Payment",
      dataIndex: "payment",
      key: "payment",
      render: (payment) => (payment ? JSON.stringify(payment) : "—"),
    },
    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <Space size="middle">
          <Tooltip title="Edit this record">
            <Button
              type="primary"
              size="small"
              icon={<EditOutlined />}
              onClick={() => console.log("Edit clicked", record)}
            >
              Edit
            </Button>
          </Tooltip>

          <Popconfirm
            title="Are you sure you want to delete this record?"
            onConfirm={() => console.log("Deleted", record.id)}
            okText="Yes"
            cancelText="No"
          >
            <Button
              danger
              type="primary"
              size="small"
              icon={<DeleteOutlined />}
            >
              Delete
            </Button>
          </Popconfirm>
        </Space>
      ),
    },
  ];

  return (
    <div className="d-flex" style={{ height: "100vh" }}>
      {/* Sidebar and Header */}
      <Header />

      {/* Main Content */}
      <div style={{ flex: "11 11 100%", padding: "20px", marginTop: "64px", minWidth: 0, overflow: "auto" }}>
        <div className="row ">
          <div className=" col-12">
            <div className="row">
              <div className="col-6">
                <h1 className="text-2xl font-bold">Orders</h1>
              </div>
              <div className="col-6 "></div>
            </div>
          </div>
        </div>
        <div className="row p-4">
          <div className="col-12 r-shadow">
            <Table
              columns={columns}
              dataSource={orders}
              scroll={{ x: "max-content" }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
export default POSOrders;
